import { useDispatch } from "react-redux"
import { practicesLocationsGroupedOptions } from "../../lib/systemData"
import CustomSelectGroupedMultiple from "../common/interactive/CustomSelectGroupedMultiple"
import { useState } from "react"
import { getItemFromStorageSimple, setStorageItem } from "../../lib/script"
import Button from "../common/Button"
import { userActions } from "../../store/user"

import classes from './MyLocations.module.css'
import { miscellaneous } from "../../lib/misc"

export default function MyLocations() {
    const dispatch = useDispatch()
    const userLocations = getItemFromStorageSimple('userLocations')
    const [loading, setLoading] = useState(false)
    const [showDoneMessage, setShowDoneMessage] = useState(false)

    const [locations, setLocations] = useState(userLocations)

    function setLocationsHandler(value) {
        setLocations(value.data.value)
    }

    function saveLocationsHandler() {
        setLoading(true)
        setStorageItem('userLocations', locations)
        dispatch(userActions.setUserLocations(locations))

        setTimeout(() => {            
            setShowDoneMessage(true)
        }, 1000)

        setTimeout(() => {
            setLoading(false)
            setShowDoneMessage(false)
        }, 2000)
    
    }

    return <div className="flex-container">
        <CustomSelectGroupedMultiple
            label="My Locations"
            name="my_locations"
            optionsData={practicesLocationsGroupedOptions()}
            preSelectedValue={locations}
            action={setLocationsHandler}
        />
        {!miscellaneous.arraysHaveSameItems(userLocations, locations) && <Button click={saveLocationsHandler} btnStyle={'btn_white'}>Save</Button>}
        {loading && !showDoneMessage && <div className={classes.loading}>Saving...</div>}
        {loading && showDoneMessage && <div className={classes.done_message}>Done!</div>}
    </div>
}